export const RESOURCES_RESET_STATE = 'RESOURCES_RESET_STATE';
export const RESOURCES_CURRENT_ITEM = 'RESOURCES_CURRENT_ITEM';

export const RESOURCES_REQUEST_LOADING = 'RESOURCES_REQUEST_LOADING';
export const RESOURCES_REQUEST_SUCCESS = 'RESOURCES_REQUEST_SUCCESS';
export const RESOURCES_REQUEST_FAILED = 'RESOURCES_REQUEST_FAILED';

export const RESOURCES_CURRENT_ACTION = 'RESOURCES_CURRENT_ACTION';
export const RESOURCES_RESET_ACTION = 'RESOURCES_RESET_ACTION';